import { render, staticRenderFns } from "./Subworks.vue?vue&type=template&id=74109512&scoped=true"
import script from "./Subworks.vue?vue&type=script&lang=js"
export * from "./Subworks.vue?vue&type=script&lang=js"
import style0 from "./Subworks.vue?vue&type=style&index=0&id=74109512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74109512",
  null
  
)

export default component.exports